import React from 'react'
import ManageProspectForm from '../../../modules/ManageProspect/Form'

const Index = () => {
  return <ManageProspectForm caseType="create" />
}
export default Index
